<template>
  <div class="teach-studio">
    <div class="teach-studio-top">
        <div class="title">名师工作室</div>
        <div class="more">更多 ></div>
        <img class="title-bg" :src="require('@/assets/images/sydataboard/title-bg.png')" alt="">
    </div>
    <div class="teach-studio-number">
        <div class="left">
            <div class="name">工作室总数</div>
            <div class="number">36</div>
        </div>
        <div class="right">
            <div class="name">工作室成员数</div>
            <div class="number">2011</div>
        </div>
    </div>
    <div class="teach-studio-title">
        <div class="left">
            <div class="color-bg"></div>
            工作室学科占比
        </div>
        <div class="right">
            <div class="color-bg"></div>
            工作室内容占比
        </div>
    </div>
    <div class="teach-studio-echarts">
        <div class="echarts-left">
            <div id="teachStudioLeftEchartsId" style="width: 100%;height: 100%"></div>
        </div>
        <div class="echarts-right">
            <div id="teachStudioRightEchartsId" style="width: 100%;height: 100%"></div>
        </div>
    </div>
    <img class="top-left" :src="require('@/assets/images/sydataboard/top-left.png')" alt="">
    <img class="top-right" :src="require('@/assets/images/sydataboard/top-right.png')" alt="">
    <img class="left-bottom" :src="require('@/assets/images/sydataboard/left-bottom.png')" alt="">
    <img class="right-bottom" :src="require('@/assets/images/sydataboard/right-bottom.png')" alt="">
  </div>
</template>
<script>
import * as echarts from 'echarts';
export default {
  name: 'teach-studio',
  data() {
    return {
        subjectList:[
            {
                name:"初中数学",
                value:50,
                number:25
            },
            {
                name:"初中语文",
                value:20,
                number:10
            },
            {
                name:"初中英语",
                value:30,
                number:15
            },
            {
                name:"初中化学",
                value:50,
                number:25
            },
            {
                name:"初中物理",
                value:50,
                number:25
            }
        ],
        typeList:[
            {
                name:"咨询公告",
                value:70,
                number:35
            },
            {
                name:"资源",
                value:48,
                number:24
            },
            {
                name:"文章",
                value:28,
                number:14
            },
            {
                name:"成果",
                value:42,
                number:21
            },
            {
                name:"教研活动",
                value:12,
                number:6
            }
        ]
    }
  },
  methods: {
    initEcharts(dom,dataList){
        let myChart = echarts.init(dom)
        let option;
        option = {
            tooltip: {
                trigger: 'item',
                // 数据的显示方式
                formatter: (param) => {
                    return `${param.data.name}  ${param.data.value}(${param.data.number}%)`
                }
            },
            legend: {
                show:false,
                selectedMode: false, // 是否允许点击
                top: 'bottom',
                left: '50%',
                textStyle: {
                    color: '#ffffff',
                    borderWidth: 2
                },
            },
            series: [
                {
                    name: 'Access From',
                    type: 'pie',
                    radius: ['40%', '70%'],
                    center: ['50%', '50%'],
                    avoidLabelOverlap: false,
                    color: ['#2B7FFF','#27CDE6','#FDBA01','#FF7642','#F35D76','#A470EB','#646BF6','#43AAEC'],
                    label: {
                        show: false,
                        position: 'center',
                        formatter: (data) => {
                            return (
                            "{a|" +
                            data.data.number +
                            "%}" +
                            "\r\n" +
                            "{b|" +
                            data.data.name +
                            "}"
                            );
                        },
                        rich: {
                            a: {
                                fontSize: 16,
                                lineHeight: 20,
                                color: "#fff",
                                align: "center",
                                fontWeight: "bold",
                            },
                            b: {
                                fontSize: 12,
                                lineHeight: 16,
                                fontWeight: "bold",
                                color: "#7ABFDB",
                                align: "center",
                            },
                        },
                        backgroundColor: "transparent",
                        fontWeight: "bold",
                        fontSize: "15",
                        padding: 6,
                    },
                    emphasis: {
                        label: {
                        show: true,
                        fontWeight: 'bold'
                        }
                    },
                    labelLine: {
                        show: false
                    },
                    data: dataList
                }
            ]
        };
        option && myChart.setOption(option)
    },
  },
  mounted(){
    this.initEcharts(document.getElementById('teachStudioLeftEchartsId'),this.subjectList);
    this.initEcharts(document.getElementById('teachStudioRightEchartsId'),this.typeList);
  }
}
</script>
<style lang='scss' scoped>
.teach-studio{
    width: 100%;
    height: 330px;
    padding: 0 15px;
    border: 1px solid #053882;
    position: relative;
    margin-bottom: 20px;
    // background: rgba(6,17,52,0.8);
    .teach-studio-top{
        position: relative;
        text-align: center;
        margin-bottom: 20px;
        .title{
            display: inline-block;
            padding: 9px 22px 8px 17px;
            font-size: 18px;
            font-family: Microsoft YaHei;
            font-weight: bold;
            color: #D0E7FE;
            line-height: 20px;
            position: relative;
            z-index: 2;
        }
        .more{
            display: inline-block;
            position: absolute;
            top: 0px;
            right: 0px;
            height: 100%;
            line-height: 44px;
            font-size: 14px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #359AFF;
            cursor: pointer;
        }
        .title-bg{
            width: auto;
            height: 100%;
            position: absolute;
            top: 0;
            left: 50%;
            transform: translateX(-50%);
        }
    }
    .teach-studio-number{
        display: flex;
        align-items: center;
        margin-bottom: 15px;
        .left,
        .right{
            width: 50%;
            text-align: left;
            display: flex;
            align-items: center;
            justify-content: flex-start;
            .name{
                font-size: 14px;
                font-family: Microsoft YaHei;
                font-weight: 400;
                color: #7ABFDB;
                margin-right: 5px;
            }
            .number{
                font-size: 16px;
                font-family: Microsoft YaHei;
                font-weight: bold;
                color: #FFFFFF;
            }
        }
    }
    .teach-studio-title{
        display: flex;
        align-items: center;
        .left,.right{
            width: 50%;
            display: flex;
            align-items: center;
            justify-content: flex-start;
            font-size: 14px;
            font-family: Adobe Heiti Std;
            font-weight: normal;
            color: #27CDE6;
            .color-bg{
                width: 14px;
                height: 14px;
                background: linear-gradient(90deg, #09132A, #0CBCC2);
                margin-right: 5px;
            }
        }
    }
    .teach-studio-echarts{
        width: 100%;
        height: 210px;
        display: flex;
        align-items: center;
        .echarts-left,
        .echarts-right{
            width: 50%;
            height: 100%;
        }
    }
    .top-left{
          position: absolute;
          top: 0;
          left: 0;
          width: 14px;
          height: 14px;
      }
      .top-right{
          position: absolute;
          top: 0;
          right: 0;
          width: 14px;
          height: 14px;
      }
      .left-bottom{
          position: absolute;
          bottom: 0;
          left: 0;
          width: 14px;
          height: 14px;
      }
      .right-bottom{
          position: absolute;
          bottom: 0;
          right: 0;
          width: 14px;
          height: 14px;
      }
}
</style>